import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

/**
 * Themed international phone input with country flag picker.
 *
 * Wraps `react-phone-number-input` in the Enchanted color palette so it
 * doesn't stick out on the checkout form. Emits E.164 strings (with `+` and
 * country code) so the backend never has to guess. Defaults to US.
 *
 * Usage:
 *   <ThemedPhoneInput value={phone} onChange={setPhone} required
 *                     data-testid="booking-phone" />
 *
 * The `onChange` fires with an E.164 string (`+15551234567`) or `undefined`
 * when the user is still typing / clears the field.
 */
export const ThemedPhoneInput = ({
  value,
  onChange,
  required = false,
  disabled = false,
  className = "",
  placeholder = "Phone number",
  "data-testid": dataTestId,
  autoComplete = "tel",
}) => {
  return (
    <div className={`themed-phone-input ${className}`}>
      <PhoneInput
        international
        defaultCountry="US"
        countryCallingCodeEditable={false}
        value={value || undefined}
        onChange={(v) => onChange(v || "")}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        autoComplete={autoComplete}
        data-testid={dataTestId}
      />
    </div>
  );
};

export default ThemedPhoneInput;
